import React, { useEffect, useState, useMemo, useRef } from "react";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../../config/config";
import axios from "axios";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../../common/Constant";
import JsBarcode from "jsbarcode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ItemBarcodeLabel = () => {
  const [formValues, setFormValues] = useState([]);

  const barcodeRefs = useRef([]);
  const barcodeRequestParam = JSON.parse(
    localStorage.getItem("BarcodeItemRequestParam")
  )?.id;
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const token = localStorage.getItem("Token");
  const settingids = localStorage.getItem("barcode-settings");
  const [selectedValue, setSelectedValue] = useState([]);

  const [placeHolder, setPlaceHolder] = useState("Load Selected Values");
  // const [selectDropdown, setSelectDropdown] = useState([]);
  const [id, setId] = useState(0);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 30,
    fontSize: 12,
    zeroFill: 5,
  });
  console.log(barcodeRequestParam, "barcodeRequestParam");
  console.log(formValues, "formValues");
  console.log(data, "databarcode");
  const exportRef = useRef();

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  // Function for generating the barcode
  //barcode old code 
  // const generateBarcodes = (listData) => {
  //   barcodeRefs.current.forEach((barcodeRef, index) => {
  //     console.log("<===== new set ===>>");
  //     console.log("barcodeRef", barcodeRef);
  //     console.log("index =>>", index);
  //     console.log("formValues ====>>", formValues);
  //     console.log(
  //       "object =>",
  //       formValues.find((el) => el.ID === index)
  //     );
  //     let BarCodeItemNumber = listData.find(
  //       (el) => el.ID === index
  //     )?.ItemNumber;
  //     console.log("ItemNumber =>>", BarCodeItemNumber);
  //     if (!BarCodeItemNumber) {
  //       BarCodeItemNumber = "TEST";
  //     }
  //     // const barcodeValue = `${index}`;
  //     // const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0"); // Zerofill at the barcode
  //     // JsBarcode(barcodeRef, paddedBarcodeValue, {
  //     JsBarcode(barcodeRef, BarCodeItemNumber, {
  //       width: data.width,
  //       height: data.height,
  //       fontSize: data.fontSize,
  //       displayValue: true,
  //       fontoptions: "bold",
  //       textAlign: "center",
  //       font: "monospace",
  //       textPosition: "bottom",
  //       textMargin: 2,
  //       margin: 10,
  //       marginTop: undefined,
  //       marginBottom: undefined,
  //       marginLeft: undefined,
  //       marginRight: undefined,
  //       format: "CODE128",
  //       valid: () => true,
  //       background: "#ffffff",
  //       lineColor: "#000000",
  //       padding: data.zeroFill,
  //     });
  //   });
  // };

  console.log(barcodeRefs, "barcodeRefs");


  const resetpage = () => {
    // window.location.reload();
    localStorage.removeItem("barcode-settings");

    setData({
      inputValue: "",
      width: 1,
      height: 30,
      fontSize: 12,
      zeroFill: 5,
    });
  };

  //working pdf downlaod
  // const downloadPdf = () => {
  //   const pdf = new jsPDF();

  //   formValues.forEach((item, index) => {
  //     // Assuming you want each barcode on a new page
  //     if (index !== 0) {
  //       pdf.addPage();
  //     }

  //     const barcodeValue = item.ItemNumber ? item.ItemNumber : "Test";
  //     const { width, height, fontSize, zeroFill } = data;
  //     // Render the barcode using JsBarcode onto a canvas
  //     const canvas = document.createElement('canvas');
  //     JsBarcode(canvas, barcodeValue, {
  //       width,
  //       height,
  //       fontSize,
  //       displayValue: true,
  //       fontoptions: "bold",
  //       textAlign: "center",
  //       font: "monospace",
  //       textPosition: "bottom",
  //       // textMargin: 1,
  //       margin: 0,
  //       format: "CODE128",
  //       valid: () => true,
  //       background: "#ffff",
  //       lineColor: "#000000",
  //       padding: zeroFill,
  //     });

  //     // Convert canvas to an image and then add it to the PDF
  //     const imgData = canvas.toDataURL('image/png');
  //     pdf.addImage(imgData, 'PNG', 10, 10); // Adjust x, y, width, height as needed
  //   });

  //   // Save the PDF or trigger a download
  //   pdf.save('barcodes.pdf');
  // };

  const downloadPdf = () => {
    const pdf = new jsPDF();
    pdf.setFontSize(11)
    
    formValues.forEach((item, index) => {
      if (index !== 0) {
        pdf.addPage();
      }

      // Add "SonarPos" text
      pdf.text("SonarPos", 25, 10, 'center');
    

      const barcodeValue = item.ItemNumber ? item.ItemNumber : "Test";
      const { width, height, fontSize, zeroFill } = data;
      // Render the barcode using JsBarcode onto a canvas
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, barcodeValue, {
        width: Number(width) ,
        height: Number(height),
        fontSize : Number(fontSize),
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        // textMargin: 1,
        margin: 0,
        format: "CODE128",
        valid: () => true,
        background: "#ffff",
        lineColor: "#000000",
        padding: Number(zeroFill),
      });

      // Convert canvas to an image and then add it to the PDF
      const imgData = canvas.toDataURL("image/png")
      console.log(imgData, canvas,  "imgData");

      // // Add UnitPrice
      pdf.text(`${item.UnitPrice} ${item.Barcodename? "| "+item.Barcodename:''}`,  10,14);
      
      pdf.addImage(imgData, "PNG", 10, 15); // Adjust x, y, width, height as needed
    
      // pdf.addImage(imgData, "PNG", 10, 11); // Adjust x, y, width, height as needed
      // // Add UnitPrice
      // pdf.text(`${item.UnitPrice} | ${item.Barcodename}`,  10, (20+((Number(height)*72)/300)));
    });

    // Save the PDF or trigger a download
    pdf.save("barcodes.pdf");
  };

  // const value = options.map(data => {
  //   console.log(settingids);
  //   if (settingids?.includes(data.Barcode_Id)) {
  //     console.log(data.Barcode_Id);
  //     // const Drop = { value: data.Barcode_Id, label: data.SaveAs_Name };
  //     // console.log(Drop);
  //     setSelectedValue({ value: data.Barcode_Id, label: data.SaveAs_Name })
  //     // return Drop;

  //   }
  //   // else {
  //   // return null;
  //   // }
  // });
  // .filter(item => item !== null);

  // localStorage.removeItem("barcode-settings");

  //Function for downloading pdf
  // const downloadPdf = () => {
  //   const pdf = new jsPDF();

  //   barcodeRefs.current.forEach((barcodeRef) => {
  //     const canvas = barcodeRef;
  //     const imgData = canvas.toDataURL("image/png");

  //     pdf.addImage(imgData, "PNG", 10, 10);
  //     pdf.addPage();
  //   });
  //   pdf.save("barcodes.pdf");
  // };

  // useEffect for getting the selected data
  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/barcodelisting`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("hello", res.data.ResponseData);
        setOptions(res.data.ResponseData);
        setLoading(false);
        // generateBarcodes();
        // handleLoadSettings();
        console.log(options);
        res.data.ResponseData.map((data) => {
          if (settingids?.includes(data?.ID)) {
            console.log(data?.ID);

            setSelectedValue({
              value: data?.ID,
              label: data?.SaveAs_Name,
            });
            //handleUpdate({ value: data?.Barcode_Id, label: data?.SaveAs_Name });
          }
        });
      });

    axios
      .get(
        `${config.itemsBaseUrl}/items/itemsdetailforlabel?id=${JSON.stringify(
          barcodeRequestParam
        )}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData, "item barcode list");
        setFormValues(res.data.ResponseData);

        //   for(let i=0; i< res.data.ResponseData?.length; i++ ){
        //   let BarCodeItemNumber = res.data.ResponseData?.find((el) => el.ID === res.data.ResponseData[i].ID)?.ItemNumber;

        //   console.log(BarCodeItemNumber, "BarCodeItemNumber")

        //   const barCodeData = JsBarcode(res.data.ResponseData, BarCodeItemNumber, {
        //      width: data.width,
        //      height: data.height,
        //      fontSize: data.fontSize,
        //      displayValue: true,
        //      fontoptions: "bold",
        //      textAlign: "center",
        //      font: "monospace",
        //      textPosition: "bottom",
        //      textMargin: 2,
        //      margin: 10,
        //      marginTop: undefined,
        //      marginBottom: undefined,
        //      marginLeft: undefined,
        //      marginRight: undefined,
        //      format: "CODE128",
        //      valid: () => true,
        //      background: "#ffffff",
        //      lineColor: "#000000",
        //      padding: data.zeroFill,
        //    });

        //    console.log(barCodeData, "barCodeData")

        //   // setTimeout(function () {
        //   // generateBarcodes();
        //   // }, 3000);
        //   // barcodeRefs.current.forEach((barcodeRef, index) => {
        //   //   console.log("<===== new set ===>>");
        //   //   console.log("barcodeRef", barcodeRef);
        //   //   console.log("index =>>", index);
        //   //   // console.log("formValues ====>>", formValues);
        //   //   console.log("object =>", res.data.ResponseData.find((el) => el.ID === index));
        //   //   let BarCodeItemNumber = res.data.ResponseData.find((el) => el.ID === index)?.ItemNumber;
        //   //   console.log("ItemNumber =>>", BarCodeItemNumber);
        //   //   if (!BarCodeItemNumber) {
        //   //     BarCodeItemNumber = "TEST";
        //   //   }
        //   //   // const barcodeValue = `${index}`;
        //   //   // const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0"); // Zerofill at the barcode
        //   //   // JsBarcode(barcodeRef, paddedBarcodeValue, {
        //   //   JsBarcode(barcodeRef, BarCodeItemNumber, {
        //   //     width: data.width,
        //   //     height: data.height,
        //   //     fontSize: data.fontSize,
        //   //     displayValue: true,
        //   //     fontoptions: "bold",
        //   //     textAlign: "center",
        //   //     font: "monospace",
        //   //     textPosition: "bottom",
        //   //     textMargin: 2,
        //   //     margin: 10,
        //   //     marginTop: undefined,
        //   //     marginBottom: undefined,
        //   //     marginLeft: undefined,
        //   //     marginRight: undefined,
        //   //     format: "CODE128",
        //   //     valid: () => true,
        //   //     background: "#ffffff",
        //   //     lineColor: "#000000",
        //   //     padding: data.zeroFill,
        //   //   });
        //   // });

        // }
      });
  }, []);

  // Function for setting the value and updating the data
  const handleUpdate = (event) => {
    console.log("select option ==>", event);
    // const selectedOption = options.find(
    //   (option) => option.value === event.value || ""
    // );
    setSelectedValue(event ? event : null);
    console.log("he", event);
    if(!event){
      setData({
        inputValue: "",
        width: 1,
        height: 30,
        fontSize: 12,
        zeroFill: 5,
      });
    }

    if(event){
      axios
        .get(
          `${config.generalBaseUrl}/generals/barcodeselectbyid?id=${event.value}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log(res.data.ResponseData[0], "===> selected deopdown data");
          setId(res.data.ResponseData[0]?.ID);
  
          const data = {
            width: res.data.ResponseData[0].BarcodeImageWidth,
            height: res.data.ResponseData[0].BarcodeImageHeight,
            fontSize: res.data.ResponseData[0].BarcodeImageFontSize,
            zeroFill: res.data.ResponseData[0].ZerofillBarcode,
            inputValue: res.data.ResponseData[0].SaveAs_Name,
          };
          setData(data);
        })
        .catch((err) => {});
    }
  };

  //Function for inserting the data
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      data.inputValue == null ||
      data.inputValue == undefined ||
      data.inputValue == ""
      // id == id
    ) {
      // generateBarcodes();
      return
    } else {
      try {
        const allDataToSend = {
          Id: id,
          BarcodeImageWidth: data.width,
          BarcodeImageHeight: data.height,
          BarcodeImageFontSize: data.fontSize,
          ZerofillBarcode: data.zeroFill,
          SaveAs_Name: data.inputValue,
        };
        const response = await axios.post(
          `${config.generalBaseUrl}/generals/barcodeupsert`,
          allDataToSend,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        );
        localStorage.setItem(
          "barcode-settings",
          JSON.stringify(response.data.ResponseID)
        );
        console.log("res", response.data.ResponseData[0]);
        console.log("name", response.data.ResponseData[0].SaveAs_Name);
        console.log("ID", response.data.ResponseData[0].ID);
        const optionsList = {
          value: response.data.ResponseData[0].ID,
          label: response.data.ResponseData[0].SaveAs_Name,
        };
        setSelectedValue(optionsList);
        console.log("option", selectedValue);

        window.location.reload();
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    }
  };

  const BarcodeRenderer = (props) => {
    const { value, width, height, fontSize, zeroFill } = props;

    useEffect(() => {
      JsBarcode(".barcode", value, {
        width,
        height,
        fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        // textMargin: 1,
        margin: 0,
        format: "CODE128",
        valid: () => true,
        background: "#ffff",
        lineColor: "#000000",
        padding: zeroFill,
      }).init();
    }, [value, width, height, fontSize, zeroFill]); // Include props in the dependency array

    return null;
  };

  const BarcodeStrip = ({ Item }) => {
    const { ItemNumber } = Item;

    return (
      <div>
        <svg
          className="barcode"
          jsbarcode-format="CODE128"
          jsbarcode-value={ItemNumber ? ItemNumber : "Test"}
          jsbarcode-textmargin="0"
        />
        <BarcodeRenderer
          value={ItemNumber ? ItemNumber : "Test"}
          width={Number(data.width)}
          height={Number(data.height)}
          fontSize={Number(data.fontSize)}
          zeroFill={Number(data.zeroFill)}
        />
      </div>
    );
  };

  console.log("selectedValue ==>", selectedValue);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            {/* <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Items</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard" style={{ marginLeft: "12px" }}>
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items"> Items List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Items Barcode Label
                </li>
              </ul>
            </div> */}

            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Items</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items"> Items List</Link>
                </li>
                <li className="breadcrumb-item active">Items Barcode Label</li>
              </ul>
            </div>
          </div>
          <br />
          <br />
          <div className="card">
            <div className="card-body">
              {/* input field */}

              <div className="col-md-4">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={options.map((data) => ({
                    value: data.ID,
                    label: data.SaveAs_Name,
                  }))}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  isClearable={true}
                  name="SelectBarcode"
                  id="SelectBarcode"
                  // options={dropdownselect}

                  value={selectedValue ? options.find((obj) => obj.value == selectedValue.value) : null}
                  onChange={(event) => handleUpdate(event)}
                  className="custom-search-select"
                  // {...(selectedValue.value !== undefined ? (
                  //   <input value={selectedValue} />
                  // ) : (
                  //   <input placeholder={placeHolder} />
                  // ))}
                  // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                />
              </div>
              <br />

              <div className="row">
                <div className="mt-2 col-sm-4">
                  <label>Barcode Image Width: </label>
                  <input
                    name="width"
                    type="number"
                    value={data.width}
                    className="form-control "
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-2 col-sm-4">
                  <label>Barcode Image Height: </label>
                  <input
                    name="height"
                    type="number"
                    value={data.height}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>

                <div className="mt-2 col-sm-4">
                  <label>Barcode Image FontSize: </label>
                  <input
                    name="fontSize"
                    type="number"
                    value={data.fontSize}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row">
                {/* <div className="mt-2 col-sm-4">
                  <label>Barcode Zero Fill: </label>
                  <input
                    name="zeroFill"
                    type="number"
                    value={data.zeroFill}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div> */}
                <div className="mt-2 col-sm-4">
                  <label>Save Settings Above As:</label>
                  <input
                    name="inputValue"
                    type="text"
                    value={data.inputValue}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  {data.inputValue !== "" &&
                    <button
                    type="submit"
                    className="btn btn-primary me-1"
                    onClick={handleSubmit}
                    >
                    Save Setting
                  </button>
                  }
                  <button
                    type="submit"
                    className="btn btn-secondary me-1"
                    onClick={resetpage}
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="btn btn-secondary"
                    onClick={downloadPdf}
                  >
                    Download PDf
                  </button>
                </div>
              </div>
              <br />
              <br />
              {/* Generating the barcode with the help of Id */}
              {/* {formValues.map((item) => (
                <div key={item.ID}>
                  <canvas
                    data-name={item.ItemNumber}
                    ref={(el) => (barcodeRefs.current[item.ItemNumber] = el)}
                    id={`barcode-${item.ItemNumber}`}
                  />
                </div>
              ))} */}
              {/* <canvas
                  data-name={item.ItemNumber}
                  ref={(el) => (barcodeRefs.current[item.ID] = el)}
                  id={`barcode-${item.ItemNumber}`}
                /> */}
              <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                {formValues.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      textAlign: "center",
                      fontSize: `${data.fontSize}`,
                    }}
                    className="p-2"
                  >
                    <span>SonarPos</span>
                    <BarcodeStrip Item={item} />
                    <span style={{ fontWeight: "bold" }}>
                      ${item.UnitPrice}
                    </span>
                    {/* <div>{`ItemNumber: ${item.ItemNumber}`}</div> */}
                    {" " + item.Barcodename}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ItemBarcodeLabel;
